import { MyFortAgentItem } from "@/api/types";
import agentDark from "@/assets/images/agent-dark-bg-aif.png";
import agentLight from "@/assets/images/agent-light-bg-aif.png";

/** 静态收益进度百分比（0-100） */
export function calcAgentProgressPct(agent: MyFortAgentItem): number {
  return BigInt(agent.staticCapUsdt || "0") > 0n
    ? Math.min(
        100,
        Number(
          (BigInt(agent.staticPaidUsdt || "0") * 100n) /
            BigInt(agent.staticCapUsdt)
        )
      )
    : 0;
}

/** AIF 释放进度百分比（0-100） */
export function calcAifProgressPct(agent: MyFortAgentItem): number {
  return agent.aifDistributeDays > 0
    ? (agent.aifPaidDays / agent.aifDistributeDays) * 100
    : 0;
}

/** 未激活 / 待激活：黑白 */
export const AGENT_IMAGE_URL_INACTIVE = agentDark;
/** 已激活 / 市场：彩色 */
export const AGENT_IMAGE_URL_ACTIVE = agentLight;

/** @deprecated 请使用 AGENT_IMAGE_URL_ACTIVE 或 AGENT_IMAGE_URL_INACTIVE */
export const AGENT_IMAGE_URL = AGENT_IMAGE_URL_ACTIVE;
